import { select, event } from 'd3-selection';
import { interval } from 'd3-timer';
import { transition } from 'd3-transition';
import { easeLinear } from 'd3-ease';
import { scaleTime } from 'd3-scale';
import { drag } from 'd3-drag';
import moment from 'moment';

export function drawCartoArrows(dataset){
	var lastDate = Object.keys(dataset[0]["dates"]).pop()

	var firstDate = moment("3-10-2020", "MM-DD-YYYY").format('l');
	var endDate = Object.keys(dataset[0]["dates"]).pop()
	var dateArr = Object.keys(dataset[0]["dates"])
	var endDate = dateArr[dateArr.length - 1]
	if (dataset[0].dates[endDate][1] === null) {
		endDate = dateArr[dateArr.length - 2]
	}
	// var endDate = moment("6-02-2020", "MM-DD-YYYY").format('l');
	var mapColor = "#e4e4e4"

	var m = {top: 20, right: 50, bottom: 20, left: 50},
	width = 900 - m.left - m.right,
	height = 650 - m.top - m.bottom,
	opts = {w: width/11, h: width/11},
	isMobile = $(window).width() < 600,
	scrollOffset = isMobile ? 20 : 150,
	sliderLabelOffset = isMobile ? -40 : -20,
	sliderTextTransform = isMobile ? 45 : 28,
	slideCircleSize = isMobile ? 20 : 9;




	var chart = select("#carto-arrows")
	var yPoint = 40;

	var svg = chart
		.append("svg")
	    .attr("fill","none")
	    .attr("viewBox", "0 0 " + width + " " + height )
	    .attr("preserveAspectRatio", "xMaxYMax meet")
	    .append("g")
	    .attr("transform", "translate(" + 0 + "," + m.top + ")");

	var slidestartDate = new Date(firstDate),
	    slideendDate = new Date(endDate);
	var timer;
	var playText = "play"
	var pauseText = "pause"

		////////// slider //////////

	var moving = false;
	var currentValue = 0;
	var targetValue = width;

	var x = scaleTime()
	    .domain([slidestartDate, slideendDate])
	    .range([0, targetValue])
	    .clamp(true)

	var playButton = select("#slider").append("button").attr("id","play-button").attr("class", playText)
	.text(playText)

	var slider = select("#slider")
		.append("svg")
	    .attr("viewBox", "0 0 " + width + " " + 50 )
		  .attr("preserveAspectRatio", "xMaxYMax meet")
	    .append("g")
	    .attr("class", "slider")
	    .attr("transform", "translate(-10," + 30 + ")");

	slider.append("line")
	    .attr("class", "track")
	    .attr("x1", x.range()[0])
	    .attr("x2", x.range()[1])
	  .select(function() { return this.parentNode.appendChild(this.cloneNode(true)); })
	    .attr("class", "track-inset")
	  .select(function() { return this.parentNode.appendChild(this.cloneNode(true)); })
	    .attr("class", "track-overlay")
	    .call(drag()
	        .on("start.interrupt", function() { slider.interrupt(); })
	        .on("start drag", function() {
	        	moving = true;
	          currentValue = event.x;
	          update(x.invert(currentValue),50); 
	        })
	        .on("end", function() {
	        	 moving = false;
	        	if (currentValue > targetValue) {
			    		currentValue = 0;
			    		clearInterval(timer);
			    		playButton.attr("class", playText).text(playText);
		    		}
	        })
	    );

	var ticksArr = [
	new Date(2020, 3, 1),
	new Date(2020, 4, 1), 
	new Date(2020, 5, 1),
	new Date(2020, 6, 1),
	new Date(2020, 7, 1),
	new Date(2020, 8, 1),
	new Date(2020, 9, 1)
	]
	
	slider.insert("g", ".track-overlay")
	    .attr("class", "ticks")
	    .attr("transform", "translate(0," + sliderTextTransform + ")")
	  .selectAll("text")
	    .data(ticksArr)
	    .enter()
	    .append("text")
	    .attr("x", d => x(d))
	    .attr("y", 0)
	    .attr("text-anchor", "middle")
	    .text(function(d) { return moment(d).format('MMM D'); });

	var handle = slider.insert("circle", ".track-overlay")
	    .attr("class", "handle")
	    .attr("r", function (d) {
	    	return slideCircleSize
	    });

	var label = slider.append("text")  
	    .attr("class", "label")
	    .attr("text-anchor", "middle")
	    .text(moment(slidestartDate).format('MMMM D'))
	    .attr("transform", "translate(0," + sliderLabelOffset + ")")
	    .style("font-weight","bold")


		playButton
	    .on("click", function() {
	    var button = select(this);
		    if (button.text() == pauseText) {
		      moving = false;
		      clearInterval(timer);
		      button.attr("class", playText).text(playText);
		    } else {
		      moving = true;
		      timer = setInterval(step, 100);
		      button.attr("class", pauseText).text(pauseText);
		    }
  		})

  //// update the map //////

	function update(date,duration) {
		handle.attr("cx", x(date));
  	label.attr("x", x(date))
  	.text(moment(date).format('MMMM D'))

		var intervalDate = moment(date).format('l');
		var dateMoment = moment(date)

		svg.selectAll(".state line")
		.transition()
		  .duration(duration)
		  .delay(0)
		  .ease(easeLinear)
			.attr("y2", function(d) { 
				if (d.dates[intervalDate] && d.dates[intervalDate][3] && d.dates[intervalDate][1]) {
					return ( (d.dates[intervalDate][3]) - (d.dates[intervalDate][1]) + yPoint )
				} else {
					return yPoint
				}
	    })
	    .attr("x1", function(d) { 
	    	if (d.dates[intervalDate] && d.dates[intervalDate][2]) {
	    		return (d.dates[intervalDate][0]); 
	    	} else {
	    		return 9.37
	    	}
	    })
	    .attr("x2", function(d) { 
	    	if (d.dates[intervalDate] && d.dates[intervalDate][2]) {
	    		return (d.dates[intervalDate][2]); 
	    	} else {
	    		return 69
	    	}
	    })     
	
	}

	function step() {
		if (select(".handle").attr("cx") == 800) {
			update(x.invert(currentValue),0);
		} else {
			update(x.invert(currentValue),400);
		}
		
	  currentValue = currentValue + (targetValue/150);
	  if (currentValue-10 > targetValue) {
	  	moving == false
	    currentValue = 0;
	    clearInterval(timer);
	    playButton.attr("class", playText).text(playText);
	  } 
	}


	//// draw the map //////

	function drawGrid(dataset) {

		handle.attr("cx", x(slideendDate));
  	label.attr("x", x(slideendDate)).text(moment(slideendDate).format('MMMM D'));
		
    svg.html("")
    var state = svg.selectAll(".state")
    .data(dataset)
    .enter().append('g')
    .attr('transform', function(d){
    	return 'translate('+d.x*opts.w+','+d.y*opts.h+')'; 
    })
    .attr("class", function(d) {
    	return " open state "+ d.state
    })

    state.append("text")
    .attr('x', 1)
    .attr('y', opts.h/2.5)
    .style('text-anchor', 'start')
    .text(function(d) {
    	return d.ap
    })

    state.append("rect")
	    .attr("class", "state-rect")
	    .attr("id", d => `state-rect-${d.state}`)
	    .attr("width", opts.w)
	    .attr("height", opts.h)
	    .attr("fill", "none")
	    .attr("stroke-width", 1)
	    .attr("stroke-opacity", 0)
    	.attr("stroke", d => {
    		return mapColor
    	})
    	.style("cursor", "pointer")
	    .style("pointer-events","visible")
	    .on("click", function() {
	    	// show all the state rows, if you filtered before
			$(".state-row").show()
	    	let id = this.id;
	    	$('html, body').animate({
	    		scrollTop: $(`#state-row-${id.slice(-2)}`).offset().top - scrollOffset
	    	}, 2000);
	    })
	    .on("mouseover", function() {
	    	select(this)
	    	.transition() 
	    	.duration(200)
	    	.attr("stroke-opacity", 0.5)
	    })
	    .on("mouseout", function() {
	    	select(this)
	    	.transition() 
	    	.duration(200)
	    	.attr("stroke-opacity", 0)
	    })

    state.append("line")
    .attr("class", "trendline")
    .attr("stroke",function(d) { 
    	return mapColor
    })
    .attr("y1", function(d) { 
    	return yPoint; 
    })
    .attr("y2", function(d) { 
    	return ( (d.dates[endDate][3]) - (d.dates[endDate][1]) + yPoint )
    })
    .attr("x1", function(d) { 
			return d.dates[endDate][0]
    })
    .attr("x2", function(d) { 
    	return (d.dates[endDate][2]); 
    })
    .attr("marker-end", function(d) {
    	return "url(#map-arrow-open)"
    })
    .attr("marker-start", function(d) {
    	return "url(#map-circle-open)"
    })

	}

	function drawWeeArrows() {

		var h = 40
		var exArrow = select("#ex-arrow")
		var arrowpath = "M0,5.1c0-0.1,0-0.2,0.1-0.5c0.1-0.8,0.6-1.5,1.1-2c0.5-0.3,1-0.6,1.7-0.6c1-0.1,2,0.3,2.5,1C5.8,3.3,5.9,3.7,6,4 c0,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0c16.8,0,33.6,0,50.4,0c0.1,0,0.1,0,0.2,0c0-1.4,0-2.8,0-4.1H57l0.1,0.1 c3.3,1.6,6.6,3.3,9.9,4.9c0,0,0.1,0,0.1,0.1v0.1c0,0-0.1,0-0.1,0.1c-3.2,1.6-6.4,3.2-9.8,4.8c-0.1,0-0.2,0.1-0.3,0.2h-0.1 c0-1.4,0-2.6,0-4c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0c-16.8,0-33.7,0-50.5,0C6,6.3,6,6.3,5.9,6.4c-0.3,0.9-1,1.6-2.2,1.8 C2.8,8.4,1.8,8.2,1.1,7.6c-0.6-0.5-0.9-1.1-1-1.8C0,5.6,0,5.4,0,5.3S0,5.2,0,5.1z"			
		var exSvg = exArrow.append("svg")

			.attr("width", 77)
	    .attr("height", h)
	  	.append("g").attr('transform', 'translate(10,'+ h/2 +')')

	  	var exPath = exSvg.append("path").attr("d",arrowpath).attr("class","open").attr("transform","rotate(0)")

	  	interval(function() {
			  exPath.transition()
			      .duration(750)
			      .attr("transform", function() {
			      	if (moving == true) {
			      		var rotateVal;
			      		var rotation = select(this).attr("transform")
			      		var regExp = /\(([^)]+)\)/;
								rotateVal = regExp.exec(rotation)[1];
			      		return "rotate("+rotateVal+")"
			      	} else {
			      		return "rotate("+randomNum(-15,15)+")"
			      	}
			      	
			      })				      
				}, 1500);

	}
	
	function randomNum(min, max) { 
	  return Math.floor(Math.random() * (max - min + 1) + min);
	}


	drawGrid(dataset);
	drawWeeArrows()

};

